import { FC, MouseEvent, ReactNode } from 'react';

import Button, { ButtonVariant } from '../button';
import Mark from '../icons/Mark';
import Typography from '../typography';

type Props = {
  optionalHeading?: string;
  icon?: ReactNode;
  iconAndHeading?: boolean;
  canClose?: boolean;
  leftSideButton?: ReactNode;
  onXClick?: (e: MouseEvent<HTMLButtonElement>) => void;
};

export const ModalHeadingTop: FC<Props> = ({
  optionalHeading = undefined,
  icon = undefined,
  iconAndHeading = false,
  canClose = true,
  leftSideButton = undefined,
  onXClick = undefined,
}) => {
  const xClicked = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onXClick?.(e);
  };

  return (
    <div className="flex w-full items-start justify-between">
      {!icon && !optionalHeading && leftSideButton && <>{leftSideButton}</>}
      {icon && !iconAndHeading && <div>{icon}</div>}
      {optionalHeading && (
        <div className="my-auto w-[85%]">
          <Typography className="flex truncate text-gray-70" variant="h7">
            {icon && iconAndHeading && <div>{icon}</div>}
            {optionalHeading}
          </Typography>
        </div>
      )}

      {/* Close button */}
      {canClose && (
        <Button
          className="ml-auto flex items-center justify-center"
          data-testid="close-button"
          isLoading={false}
          variant={ButtonVariant.GHOST}
          onClick={xClicked}
        >
          <Mark className="h-[16px] w-[16px] text-gray-90" />
        </Button>
      )}
    </div>
  );
};
